import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalPlaceholderComponent } from '../modal-placeholder.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalModalService } from '../../../services/global-modal.service';
import { HelpersService } from '../../../services/helpers.service';
import { appPaths } from '../../../../app.paths';
import { Router } from '@angular/router';

@Component({
  selector: 'app-interstitial-hcp',
  imports: [ModalPlaceholderComponent],
  templateUrl: './interstitial-hcp.html',
  styleUrl: './interstitial-hcp.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterstitialHcp {
  appPaths = appPaths;

  @Input() url: string = '';

  constructor(
    private helpersService: HelpersService,
    private globalModalService: GlobalModalService,
    private activeModal: NgbActiveModal,
    private router: Router,
  ) {}

  continue(url: string) {
    if (!this.helpersService.validatePlatform()) return;
    this.globalModalService.setScrollingInPage();
    this.activeModal.close();
    this.router.navigateByUrl(url);
  }

  close() {
    this.globalModalService.setScrollingInPage();
    this.activeModal.close();
    this.router.navigate(['/']);
  }
}
